import React from 'react';
import { styled } from '@compiled/react';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import { token } from '@atlaskit/tokens';

export const DropdownIndicator = () => (
	<DropDownIndicatorContainer>
		<SearchIcon spacing="spacious" label="" />
	</DropDownIndicatorContainer>
);

// Styles taken from PopupSelect/components.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DropDownIndicatorContainer = styled.div({
	marginRight: token('space.025'),
	textAlign: 'center',
	width: 32,
});
